import React from "react"
import { Cell } from "fixed-data-table-2"
import moment from "moment"

// Component to render the month and day of a birthday
// expects that children will be of the from 'YYYY-MM-DD' to pass to moment
const BirthMonthDayCell = ({ rowId, columnId, children, sheetId, columnIndex, editing, ...props }) => {
    return <Cell {...props}>{children ? moment(children).format('MMMM DD') : undefined}</Cell>
}

export default BirthMonthDayCell
